import { t, currentLang } from 'translations'
import { store } from 'store/reducers'

type GetRequestTypeNames = (requestTypeArray: Array<string | Record<string, string>>, options?: { key?: string; delimiter?: string }) => string
export const getRequestTypeNames: GetRequestTypeNames = (requestTypeArray = [], { key = '_id', delimiter = ' - ' } = {}) => {
  return requestTypeArray
    .map(requestType => {
      return typeof requestType === 'object' ? getRequestTypeName(requestType[key]) : getRequestTypeName(requestType)
    })
    .join(delimiter)
}

type GetRequestTypeName = (requestTypeId: string, options?: { canBeNull?: boolean; noValue?: string }) => string
export const getRequestTypeName: GetRequestTypeName = (requestTypeId, { canBeNull, noValue = 'N/A' } = {}) => {
  const {
    resources: { attendanceTypesById, timeOffTypesById }
  } = store.getState() as MStore.RootState

  const requestTypesById = { ...attendanceTypesById, ...timeOffTypesById }

  if (!requestTypeId) return ''
  if (!requestTypesById[requestTypeId] && !canBeNull) return t('components.REQUEST_TYPE_DELETED')
  if (!requestTypesById[requestTypeId]) return noValue

  return requestTypesById[requestTypeId][`name${currentLang(true)}`]
}
